import { DialogContentText } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import {
  Button, Dialog
} from 'src/components';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import { useAppDispatch, useAppSelector } from "src/store";
import CommonSlice from 'src/store/Slices/CommonSlice';
import { translate } from 'src/i18n/tHelper';

const translatePath = "common";


const CommonDialog = (props): JSX.Element => {
  const commonState = useAppSelector(s => s.common);
  const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (commonState.error)
      setOpen(true);
  }, [commonState.error]);

  const closeHandler = () => {
    dispatch(CommonSlice.actions.setError(""));
    dispatch(CommonSlice.actions.setState({ error: "" }));
    setOpen(false)
  };

  return (
    <>
      <Dialog
        fullWidth
        open={open}
        maxWidth="sm"
        scroll="paper"
        keepMounted
        sx={{
          zIndex: 32767
        }}
        onKeyDown={(e) => {
          if (open && (e.code === "Space" || e.code === "Enter")) {
            closeHandler();
            e.preventDefault();
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">{translate(translatePath, "Hata Mesajı")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{commonState.error}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button customType='check' onClick={closeHandler}>
            {translate(translatePath, "Tamam")}
          </Button>
        </DialogActions>
      </Dialog >
    </>
  );
};

export default CommonDialog;